import request from 'src/utils/request';

/**
 * 获取中心列表（看货源/看需求）
 * @param {Object} params - 请求参数
 * @param {string} params.type - 发布类型：供应、需求（可选）
 * @param {string} params.cName - 模糊搜索（可选）
 * @param {Array<string>} params.plateTypes - 板块列表（可选）
 * @param {Array<number>} params.provinces - 地区列表（可选）
 * @param {Array<string>} params.organizations - 猪场公司列表（必需）
 * @param {string} params.sort - 排序类型：最新发布、价格低到高、价格高到低（可选）
 * @param {number} params.pageIndex - 当前页码（可选）
 * @param {number} params.pageSize - 每页数据量（可选）
 * @returns {Promise}
 */
export const getCenterList = (params) => {
    return request.post('/public/PorkOrderRecord/GetCenterList', params);
};